import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { PageLink, Vector } from "../../../types";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";
import { Link } from "../../elements/Link/Link";
import * as styles from "./QuickLinks.module.css";

interface Props {
  quicklinks: QuickLink[];
  display: number;
}

interface QuickLink {
  vector?: Vector;
  link: PageLink;
  personalization?: string[];
  score: number;
}

export const QuickLinks: React.FC<Props> = ({ quicklinks, display = 6 }) => {
  const [opacity, setOpacity] = useState(0);
  const [visibleLinks, setVisibleLinks] = useState<QuickLink[]>(
    quicklinks.slice(0, display)
  );

  useEffect(() => {
    const terms = new Map();
    quicklinks.forEach((quicklink) => {
      quicklink.score = 0;

      quicklink.personalization?.forEach((term) => {
        let termScore = 0;

        if (!terms.has(term)) {
          termScore = Number(Cookies.get(`ep_${term}`)) || 0;
          terms.set(term, termScore);
        } else {
          termScore = terms.get(term);
        }

        if (termScore > quicklink.score) {
          quicklink.score = termScore;
        }
      });
    });

    quicklinks.sort((a, b) => {
      return b.score - a.score;
    });

    setVisibleLinks(quicklinks.slice(0, display));
    setOpacity(1);
  }, [quicklinks]);

  return (
    <div className={styles.quicklinks} style={{ opacity: opacity }}>
      {visibleLinks.map((quicklink, idx) => (
        <Link className={styles.quicklink} to={quicklink.link.href} key={idx}>
          {quicklink.vector?.item?.url && (
            <div
              className={styles.vector}
              data-kontent-element-codename="vector"
            >
              <KontentImageElement
                aspectRatio={1}
                objectFit="contain"
                layout="constrained"
                width={80}
                image={quicklink.vector?.item}
                alt={quicklink.vector?.alt}
              />
            </div>
          )}
          {quicklink.link?.label && (
            <p className={styles.link}>{quicklink.link?.label}</p>
          )}
        </Link>
      ))}
    </div>
  );
};
